import AlertIcon from './alert_icon';

export default AlertIcon;
